<template>
    <v-row class="d-flex align-center flex-wrap ma-0 pa-0">

        <!-- Selezione vista calendario -->
        <v-btn-toggle v-model="localVista" mandatory class="rounded-lg my-toggle mr-2 mt-2" :dense="dense">
            <v-btn value="month" icon v-tooltip.bottom="'Vista mensile'">
                <v-icon>calendar_view_month</v-icon>
            </v-btn>
            <v-btn value="week" icon v-tooltip.bottom="'Vista settimanale'">
                <v-icon>calendar_view_week</v-icon>
            </v-btn>
            <v-btn value="day" icon v-tooltip.bottom="'Vista giornaliera'">
                <v-icon>calendar_view_day</v-icon>
            </v-btn>
            <v-btn value="agenda" icon v-tooltip.bottom="'Programma'">
                <v-icon>view_agenda</v-icon>
            </v-btn>
        </v-btn-toggle>

        <!-- Refresh -->
        <v-btn text icon class="ml-0 mt-2" v-tooltip.bottom="'Aggiorna'" @click="$emit('refresh')">
            <v-icon>refresh</v-icon>
        </v-btn>

        <!-- Navigazione mese/periodo -->
        <v-btn class="mt-2" text icon @click="$emit('prev')" v-tooltip.bottom="'Precedente'">
            <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>

        <v-btn class="mt-2 pl-0 pr-0" text small @click="$emit('oggi')"
            style="min-width: 90px; text-align: center; font-weight:600;">
            {{ periodoCorrente }}
        </v-btn>

        <v-btn class="mt-2" text icon @click="$emit('next')" v-tooltip.bottom="'Successivo'">
            <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>

        <!-- Aggiungi ore (solo desktop) -->
        <v-btn v-if="!$vuetify.breakpoint.smAndDown" icon color="primary" class="mt-2" v-tooltip.bottom="'Nuove ore'"
            @click="$emit('apriDialog')">
            <v-icon>schedule</v-icon>
        </v-btn>

        <!-- Aggiungi attività (solo desktop) -->
        <v-btn v-if="!$vuetify.breakpoint.smAndDown" icon color="teal" class="mt-2"
            v-tooltip.bottom="'Nuova attività / appuntamento'" @click="$emit('apriDialogTask')">
            <v-icon>task_alt</v-icon>
        </v-btn>

        <!-- Toggle promemoria -->
        <v-btn icon class="mt-2 ml-1" :color="localMostraPromemoria ? 'blue-grey' : 'grey lighten-1'"
            v-tooltip.bottom="localMostraPromemoria ? 'Nascondi promemoria' : 'Mostra promemoria'"
            @click="localMostraPromemoria = !localMostraPromemoria">
            <v-icon>notifications{{ localMostraPromemoria ? '' : '_off' }}</v-icon>
        </v-btn>

        <!-- Filtro utente -->
        <v-select v-if="role === 'admin'" class="ml-2 mt-2" :items="filtriUtenti" v-model="localFiltroUtenteSel"
            label="Utente" hide-details :dense="dense" @change="$emit('refresh')" style="max-width: 120px;" />

        <!-- Esporta -->
        <v-btn v-if="role === 'admin'" icon color="primary" class="ml-2 mt-2" v-tooltip.bottom="'Esporta Excel'"
            @click="$emit('esportaExcel')">
            <v-icon>grid_on</v-icon>
        </v-btn>

        <!-- Mostra completate (visibile solo in vista con tasks) -->
        <v-checkbox v-model="localMostraCompletate" label="Completate" class="ml-3 mt-2 pt-0" hide-details
            :dense="dense" @change="$emit('refresh')" />

        <v-spacer />

        <v-chip class="ml-3 mt-2 pt-0">
            Totale ore: {{ totaleOreLavoro.toFixed(2) }}
        </v-chip>
        <!-- Cerca -->
        <v-text-field v-model="localSearch" append-icon="search" label="Cerca" hide-details clearable
            class="ml-2 pb-1 mt-2" :dense="dense" style="max-width: 180px;" />
    </v-row>
</template>

<script>
export default {
    props: {
        today: String,
        role: String,
        vista: { type: String, default: 'month' },
        filtroUtenteSel: String,
        filtriUtenti: Array,
        mostraCompletate: Boolean,
        mostraPromemoria: { type: Boolean, default: true },
        search: String,
        dense: Boolean,
        totaleOreLavoro: Number,
    },

    computed: {
        periodoCorrente() {
            const d = new Date(this.today + 'T00:00:00');
            if (this.vista === 'month' || this.vista === 'agenda') {
                return d.toLocaleString('it', { month: 'long', year: 'numeric' });
            }
            if (this.vista === 'week') {
                // Inizio settimana (lunedì)
                const day = d.getDay() || 7;
                const lunedi = new Date(d);
                lunedi.setDate(d.getDate() - day + 1);
                const domenica = new Date(lunedi);
                domenica.setDate(lunedi.getDate() + 6);
                return `${lunedi.getDate()}/${lunedi.getMonth() + 1} - ${domenica.getDate()}/${domenica.getMonth() + 1}`;
            }
            if (this.vista === 'day') {
                return d.toLocaleDateString('it', { weekday: 'short', day: 'numeric', month: 'short' });
            }
            return '';
        },

        localVista: {
            get() { return this.vista; },
            set(v) { this.$emit('update:vista', v); },
        },
        localFiltroUtenteSel: {
            get() { return this.filtroUtenteSel; },
            set(v) { this.$emit('update:filtroUtenteSel', v); },
        },
        localMostraCompletate: {
            get() { return this.mostraCompletate; },
            set(v) { this.$emit('update:mostraCompletate', v); },
        },
        localMostraPromemoria: {
            get() { return this.mostraPromemoria; },
            set(v) { this.$emit('update:mostraPromemoria', v); },
        },
        localSearch: {
            get() { return this.search; },
            set(v) { this.$emit('update:search', v); },
        },
    },
};
</script>

<style scoped></style>